import React from 'react'

const BusinessChartIcon = () => {
  return (
    <svg viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 21.9792H5C4.46957 21.9792 3.96086 21.7685 3.58579 21.3935C3.21071 21.0184 3 20.5097 3 19.9792V3.97925"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 6.97925L16.402 12.4972C16.2816 12.6418 16.1228 12.7494 15.944 12.8078C15.7652 12.8662 15.5735 12.8729 15.391 12.8272L12.609 12.1312C12.4265 12.0856 12.2348 12.0923 12.056 12.1507C11.8772 12.2091 11.7184 12.3167 11.598 12.4612L7 17.9792"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { BusinessChartIcon }
